import { GetterTree } from "vuex";
import { EventData, State, User } from "./state";
import { isEmpty, isNil, chunk } from "lodash";
import { timeLabelGenerator, getLabelTop, getMonths } from "../utils";

export type Getters = {
  usernameExist(state: State): boolean;
  getUserID(state: State): null | string;
  getEventData(state: State): EventData;
  getAvailability(state: State): { [key: string]: string[] };
  getSplitAvailabilities(state: State, getters: Getters): string[][][] | void;
  getEventName(state: State): string;
  getTimeLabels(state: State): string[];
  getTopLabel(state: State): string;
  getPageNumbers(state: State, getters: Getters): number;
  getParticipantList(state: State): User[];
  getEventDetails(state: State): {
    created: string;
    author: string;
    participants: number;
  };
};

export const getters: GetterTree<State, State> & Getters = {
  usernameExist(state) {
    return state.userID.length > 0;
  },
  getUserID(state) {
    return state.userID;
  },
  getEventData(state) {
    return state.eventData;
  },
  getAvailability(state) {
    return state.eventData.availability;
  },
  getSplitAvailabilities(state, getters) {
    // Return all days in a single continuous view (no pagination)
    // dimension 1: always single page [0]
    // dimension 2: all days
    // dimension 3: hours per day

    if (isEmpty(state.eventData)) {
      return [[[]]];
    }
    const numofTimings = getters.getTimeLabels.length;
    const arr = Object.keys(state.eventData.availability);
    const days = chunk(arr, numofTimings);

    // Return all days in a single page
    return [days];
  },

  getPageNumbers(state, getters) {
    // Always 0 since we only have one page now
    return 0;
  },

  getEventName(state) {
    return state.eventData.event_name;
  },
  getTimeLabels(state) {
    if (isEmpty(state.eventData)) {
      return [];
    }
    return timeLabelGenerator(
      state.eventData.start_time,
      state.eventData.end_time
    );
  },
  getTopLabel(state) {
    if (isEmpty(state.eventData)) {
      return "";
    }
    return getLabelTop(state.eventData.start_date, state.eventData.end_date);
  },
  getParticipantList(state) {
    if (isEmpty(state.eventData)) {
      return [];
    }
    return state.eventData.users;
  },
  getEventDetails(state) {
    if (isEmpty(state.eventData)) {
      return { created: "", author: "", participants: 0 };
    }
    const date = new Date(state.eventData.created_at);
    const monthNames = getMonths();
    const created = `${date.getDate()} ${
      monthNames[date.getMonth()]
    } ${date.getFullYear()}`;
    const participants = state.eventData.users.length;
    let author;
    if (participants === 0) {
      author = "unknown";
    } else {
      author = state.eventData.users[0].name;
    }
    return { created, author, participants };
  },
};
